(function () {
  var params = new URLSearchParams(window.location.search);

  if (params.has('open_cart')) {
    params.delete('open_cart');
    var newUrl =
      window.location.pathname +
      (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newUrl);

    var tryOpen = setInterval(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        clearInterval(tryOpen);
        drawer.open();
      }
    }, 100);
    setTimeout(function () {
      clearInterval(tryOpen);
    }, 5000);
  }
})();
